"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipManagmentB2BService = void 0;
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
class MembershipManagmentB2BService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        //https://q80i0bir9k.execute-api.us-east-1.amazonaws.com/devel/users/b2b/groups_companies?type=company
        //https://q80i0bir9k.execute-api.us-east-1.amazonaws.com/devel/users/b2b/groups_companies?type=group&companyId=80
        this.getCatalogCompanies = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/groups_companies?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogMembership = async () => {
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/membership_cat`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogPeriod = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/membership_period?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogAddon = async () => {
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/add_on_products`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogPrograms = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/products_by_membership?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogCreateBy = async () => {
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/create_by`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogUsersReport = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/create_users_report?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCreateCompanies = async (body) => {
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/groups_companies`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postVerifyEmail = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/validate_email?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCreateUsers = async (body) => {
            const URL = `${environment_1.API_URL_BASE_V2}/${this.ENV}/users/b2b/create_users`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postAssignMembership = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/market-place/memberships/manual-membership-assignment`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postEnrollUsers = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/products/enrollment`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postUpdateLogs = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/users/b2b/update_log`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.MembershipManagmentB2BService = MembershipManagmentB2BService;
